import {
    Stack,
    Typography,
    Tooltip,
    capitalize,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import { Order, Settlement } from '../../../Models';

const npsEmojis: Record<number, string> = {
    0: '0️⃣',
    1: '1️⃣',
    2: '2️⃣',
    3: '3️⃣',
    4: '4️⃣',
    5: '5️⃣',
    6: '6️⃣',
    7: '7️⃣',
    8: '8️⃣',
    9: '9️⃣',
    10: '🔟',
};

type TitleBarProps = {
    order: Order;
    settlement: Settlement;
};

function TitleBar({ order, settlement }: TitleBarProps) {
    const [openDialog, setOpenDialog] = useState(false);
    const origin = order.feedback?.origin
        ? capitalize(order.feedback.origin.split('_').join(' '))
        : '';
    return (
        <Grid
            xs={12}
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent="space-between"
            p={0}>
            <Stack direction="row" spacing={10} alignItems="center">
                <Stack justifyContent="space-between">
                    <Typography variant="h6">{`Pedido #${order.short_id}`}</Typography>
                    <Typography>
                        {dayjs(order.creation_timestamp).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                </Stack>
                {order.feedback && (
                    <Stack sx={{ maxWidth: 200 }}>
                        <Stack spacing={3} direction="row" sx={{ pl: 1 }}>
                            {order.feedback.nps && (
                                <Tooltip
                                    title="Calificación del servicio por el cliente, del 1 a 10 "
                                    arrow>
                                    <Typography>
                                        {npsEmojis[order.feedback.nps]}/10{' '}
                                        {(order.feedback.nps === 9 || order.feedback.nps === 10) &&
                                            '🎉'}
                                    </Typography>
                                </Tooltip>
                            )}
                            {order.feedback.origin && (
                                <Tooltip
                                    title="Se le preguntó al cliente ¿Cómo encontró el número de Delfar?"
                                    arrow>
                                    <Typography noWrap>📣 {origin}</Typography>
                                </Tooltip>
                            )}
                        </Stack>
                        {order.feedback.comment && (
                            <Tooltip
                                title="Comentario del cliente sobre la atención y el servicio"
                                arrow>
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setOpenDialog(true)}
                                    sx={{ textAlign: 'left', textTransform: 'none' }}>
                                    <Typography noWrap>💬 {order.feedback.comment}</Typography>
                                </Button>
                            </Tooltip>
                        )}
                        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                            <DialogTitle>Feedback del Cliente</DialogTitle>
                            <DialogContent>
                                <Typography gutterBottom>
                                    <strong>NPS:</strong> {order.feedback.nps}/10
                                </Typography>
                                <Typography gutterBottom>
                                    <strong>Origen:</strong> {origin}
                                </Typography>
                                <Typography>
                                    <strong>Comentario:</strong> {order.feedback.comment}
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setOpenDialog(false)}>Cerrar</Button>
                            </DialogActions>
                        </Dialog>
                    </Stack>
                )}
            </Stack>
            {settlement.payment?.external_id && (
                <Button
                    variant="text"
                    onClick={() =>
                        window.open(
                            `https://www.mercadopago.com.ar/activities/1?q=${settlement.payment.external_id}`,
                            '_blank',
                        )
                    }>
                    {`🤝 #${settlement.payment.external_id}`}
                </Button>
            )}
        </Grid>
    );
}

export default TitleBar;
